export default "__VITE_ASSET__CYYwBrMn__"